import { OptionType, ReasonType, SideEnum, WeightEnum } from '@/state/reducers'

export function generateMarkdown(
  options: OptionType[],
  reasons: ReasonType[],
  fileName?: string,
): string {
  const lines: string[] = []

  if (fileName) {
    lines.push(`# ${fileName}`)
    lines.push('')
  }

  for (const option of options) {
    lines.push(`## ${option.label}`)
    lines.push('')

    const optionReasons = reasons.filter((r) => r.optionId === option.id)
    const pros = optionReasons.filter((r) => r.side === SideEnum.PRO)
    const cons = optionReasons.filter((r) => r.side === SideEnum.CON)

    if (pros.length > 0) {
      lines.push('### Pros')
      for (const pro of pros) {
        const label =
          pro.weight === WeightEnum.HIGH ? `**${pro.label}**` : pro.label
        lines.push(`+ ${label}`)
      }
      lines.push('')
    }

    if (cons.length > 0) {
      lines.push('### Cons')
      for (const con of cons) {
        const label =
          con.weight === WeightEnum.HIGH ? `**${con.label}**` : con.label
        lines.push(`- ${label}`)
      }
      lines.push('')
    }
  }

  return lines.join('\n')
}
